import React from 'react'

import { ButtonType } from 'src/apollo/sites'

import { t } from 'src/translations'

import Image from 'shared/components/common/Image'
import { BrandedButton } from 'shared/components/common/button'

type Props = {
  errorMessage: string
  restart: () => void
}

const ReservationError = ({ errorMessage, restart }: Props) => {
  return (
    <div className='errorSection' data-testid='reservation-error'>
      <div className='error'>
        <Image alt='Warning icon' src='icons/warning-red.svg' />
        {errorMessage}
      </div>
      <BrandedButton
        variant={ButtonType.Secondary}
        className='secondary-btn'
        onClick={restart}
      >
        <div>{t('reservation-error.restart')}</div>
      </BrandedButton>
    </div>
  )
}

export default ReservationError
